import { createSlice } from "@reduxjs/toolkit";

const initialWhCatalogState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  meta: {total : 0},
  links: null,
  lastError: null,
  whCatalogForEdit: undefined,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const whCatalogSlice = createSlice({
  name: "whCatalog",
  initialState: initialWhCatalogState,
  reducers: {
		catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
		whCatalogFetched: (state, action) => {
      const { entities, meta, links } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.meta = meta;
      state.links = links;
    },
		whCatalogAllFetched: (state, action) => {
      const { count, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = count;
    },
    whCatalogCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.whCatalog.push(action.payload.whCatalog);
    },
    whCatalogDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.whCatalog.filter(el => el.wh_catalog_id !== action.payload.id);
    },
    getWhCatalog: (state, action) => {
      state.actionsLoading = false;
      state.whCatalogForEdit = action.payload.whCatalogForEdit;
      state.error = null;
    },
    // updateProduct
    whCatalogUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.whCatalog = state.entities.whCatalog.map(entity => {
        if (entity.wh_catalog_id === action.payload.whCatalog.wh_catalog_id) {
          return action.payload.whCatalog;
        }
        return entity;
      });
    },
  },
});
